export default {
  getEmailQuery(slots) {
    return /* GraphQL */`
      query EmailQuery {
        company {
          id
          handle
          name
          domain(where: { primary: true }) {
            domain(prefix:"https://")
            emailFrom
          }
  
          branding {
            name
            bigLogo {
              id
              fileLocation
            }
            headerFont
            bodyFont
            primaryColour
            secondaryColour
            backgroundColour
            emailHeaderImage {
              id
              fileLocation
            }
          }
  
          ${slots && slots.company ? slots.company : ''}
        }
        user {
          id
          firstName
          fullName
          title
          company
          emailAddress
  
          ${slots && slots.user ? slots.user : ''}
        }
      }
    `;
  },
  buildTestEmail(template, properties, { data, variables } = {}) {
    return entry => {
      const email = {
        template,
        tags: { campaign: 'test' },
      };

      if (data) {
        email.data = { ...data };
      }

      if (variables) {
        email.variables = { ...variables };
      }

      for (const key in properties) {
        if (properties.hasOwnProperty(key)) {
          const { [properties[key]]: { value } = {} } = entry;
          if (value) {
            email.data = email.data || {};
            email.data.company = email.data.company || {};
            email.data.company[key] = { value };
          }
        }
      }

      return email;
    };
  },
};



// WEBPACK FOOTER //
// ./src/emails/previews/misc.js